import {DB} from '@/firebase/db';

export default{
    initNewBatch: function(table, isCreation, object){
        var batch = DB.batch();
        var ref = DB.collection(table).doc(object.id);
        if(isCreation)
            batch.set(ref, object);
        else
            batch.update(ref, object);

        return batch;
    },
    addToBatch: function(batch, table, isCreation, object){
        var ref = DB.collection(table).doc(object.id);
        if(isCreation){
            batch.set(ref, object);
        }else{
            batch.update(ref, object);
        }
    },
    deleteByBatch: function(batch, table, id){
        var ref = DB.collection(table).doc(id);
        batch.delete(ref);
    },
    commitBatch(batch){
        return batch.commit();
    },
    create: function(table, id, data){
        return DB.collection(table).doc(id).set(data);
    },
    update: function(table, id, data){
        return DB.collection(table).doc(id).update(data);
    },
    delete: function(table, id){
        return DB.collection(table).doc(id).delete();
    },
    createWithUniquenessValidation: async function(table, id, date, filters){
        let count = await this.count(table, filters);
        if(count == 0){
            return this.create(table, id, date);
        }else{
            return new Promise(function(resolve, reject){
                reject();
            });
        }
    },
    count: async function(table, filters){

        let collectionRef = DB.collection(table);
        for(let filter of filters){
            collectionRef.where(filter[0], filter[1], filter[2]);
        }
        const snapshot = await collectionRef.count().get();

        return snapshot.data().count;
    },
    get: async function(table, id){
        const queryResponse = await DB.collection(table).where('id', '==', id).get();
        for(const doc of queryResponse.docs){
            return doc.data();
        }
        return null;
    },
    getAll: async function(table, filters, orderBy){
        
        let query = await DB.collection(table);
        for(let x of filters){
            query = query.where(x[0], x[1], x[2]);
        }

        for(let y of orderBy){
            query = query.orderBy(y[0], y[1]);
        }

        const records = await query.get();

        let data = [];
        for(const doc of records.docs){
            data.push(doc.data());
        }

        return data;
    }
}